import MainService from './MainService';

let loadPromise = null;
const byId = new Map();
const byName = new Map();
const listeners = new Set();

const parseStatuses = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.Data)) return response.Data;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

const notify = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (err) {
      console.error('statusLookup listener error:', err);
    }
  });
};

export const ensureStatusLookup = () => {
  if (loadPromise) return loadPromise;

  loadPromise = MainService.StatusInDropDown()
    .then((response) => {
      const statuses = parseStatuses(response);
      byId.clear();
      byName.clear();
      statuses.forEach((status) => {
        if (!status) return;
        const color = status.Color || null;
        if (status.Id != null && status.Id !== '') {
          byId.set(Number(status.Id), color);
        }
        if (status.Name) {
          byName.set(String(status.Name).trim().toLowerCase(), color);
        }
        if (status.Keyword) {
          byName.set(String(status.Keyword).trim().toLowerCase(), color);
        }
      });
      notify();
      return statuses;
    })
    .catch((err) => {
      console.error('Failed to load StatusInDropDown:', err);
      loadPromise = null;
      return [];
    });

  return loadPromise;
};

export const subscribeStatusLookup = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const resolveStatusColor = ({ color, name, statusId, status } = {}) => {
  if (color) return color;
  if (status?.Color) return status.Color;

  const id = statusId ?? status?.Id;
  if (id != null && id !== '' && byId.has(Number(id))) {
    return byId.get(Number(id));
  }

  const label = name ?? status?.Name ?? status?.Keyword;
  if (label) {
    const key = String(label).trim().toLowerCase();
    if (byName.has(key)) return byName.get(key);
  }

  return null;
};

export const getStatusChipStyle = (color) => {
  if (!color) {
    return {
      backgroundColor: '#E5E7EB',
      color: '#374151',
    };
  }

  return {
    backgroundColor: `${color}20`,
    color,
  };
};
